
//CART PROBLEM
if (meta.page.pageType == 'cart') {
  let cartFound = -1;
  let cartPrice = -1;

  document.querySelectorAll(".affirm-as-low-as").forEach(function(element) {
      if (element.getAttribute("data-page-type") == "cart") {
        ++cartFound;
      }
  });

  //no affirm data-page-type cart found, manually add it ALA
  if (cartFound == -1) {
    document.addEventListener("DOMContentLoaded", function(){
      cartPriceToInsert = document.querySelector(".cart__total-container .heading.h6 span:last-child").textContent.replace(/\D/g, "");

      let affirmCartHtml = `<p class='affirm-as-low-as' data-page-type='cart' data-amount=${cartPriceToInsert}></p>`;
      document.querySelector(".cart__total-container")?.insertAdjacentHTML("afterend", affirmCartHtml);
    }) 
  }
  
}




//DRAWER PROBLEM
const miniCart = document.querySelector('#shopify-section-mini-cart');
let html, newPrice;
 
const affirmObserver = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
        let drawer = document.querySelector(".lock-all");
        let checkoutButton = document.querySelector(".checkout-button");
        if (drawer) {
            if (checkoutButton.previousSibling.className != 'affirm-as-low-as') {
                newPrice = document.querySelector(".checkout-button").textContent.trim().replace(/\D/g, "");
        
                affirm.ui.ready(function() {
                  html = `<p class='affirm-as-low-as' data-page-type='product' data-amount=${newPrice}></p>`;
                  document.querySelector(".checkout-button")?.insertAdjacentHTML("beforebegin", html);
                  
                  affirm.ui.refresh();
                });
            }
        } 

    });
});

miniCart && affirmObserver.observe(miniCart, { childList: true, attributes: true, subtree: true });